<template>
    <div>
        <div class="form-group">
            <label class="control-label">API Type</label>
            <select class="form-control" v-model="model.api">
                <option value="Asana">Asana</option>
            </select>
        </div>

        <div class="form-group">
            <label class="control-label">Key</label>
            <input class="form-control" type="text" v-model="model.key">
        </div>

        <div class="buttons">
            <button @click.prevent="store" type="submit" class="btn btn-success btn-sm">
                <span>Create</span>
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                model: {
                    key: '',
                    api: 'Custom',
                    data: {}
                }
            }
        },
        created() {
        },
        methods: {
            reset() {
                this.model = {
                    key: '',
                    api: 'Custom',
                    data: {}
                }
            },
            callback(data) {
                console.log('callback function');
                console.log(data);
                this.$eventHub.$emit('closeRightPanel');
            },
            store() {
                this.$store('/api/account-api/store', this);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
        }
    }
</script>
<style>
    #savedLinks {
        text-align: center;
        min-height: 100px;
    }
    .clickable{
        cursor: pointer;
    }
</style>